//////////////////////////////////////////
// EXPORT STATE
/////////////////////////////////////////
export default {
  formatList: [],
  canSaveLocal: false,
  restrictedSize: false,
  upgradeEvent: false,
  closeButton: false,
  openedMode: 'iframe',
  editor: {
    maxWidth: 2000,
    maxHeight: 2000
  },
  currentFormat: {
    network: 'instagram',
    width: 864,
    height: 1080,
    format: 'publication',
    icon: 'instagram',
    font: 'fa',
    label: 'intagram 4:5'
  },
  saveMenuList: [],
  templates: [],
  currentTemplate: -1,
  fontFormat: {
    fontFamily: 'Roboto',
    textAlign: 'left',
    fontSize: '30',
    fontWeight: 'normal',
    fontStyle: 'normal',
    underline: false
  },
  currentColor: '#03a9f4',
  colorList: [],
  limitations: {},
  currentLang: 'fr',
  domain: ''
}



// WEBPACK FOOTER //
// ./src/model/store/state.js